import { Component, OnInit, TemplateRef, inject } from '@angular/core';

import { APIService } from 'app/services/api.service';
import { AuthenticationService, authUserType } from 'app/services/auth.service';
import { LoaderService } from "app/services/loader.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppConfig } from "app/app.config";
import { AdvisorContactComponent } from "app/modules/shared/advisor-contact.component";
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { NgClass } from '@angular/common';
import { AdvisorContactComponent as AdvisorContactComponent_1 } from '../shared/advisor-contact.component';

type advisorType = {
  WebsiteUrl: string;
  ImageUrl: string;
  SupportName: string;
  Type: string;
  Title: string;
  PhoneNumber: string;
  Email: string;
  IsPrimary: boolean;
  Designations: string;
  DirectPhoneNumber: string;
};

@Component({
    selector: 'nwm-advisor',
    templateUrl: 'advisor.component.html',
    styleUrls: ['advisor.component.scss'],
    imports: [MenuComponent, NgClass, AdvisorContactComponent_1]
})

export class AdvisorComponent implements OnInit {
  private api = inject(APIService);
  private auth = inject(AuthenticationService);
  private loaderService = inject(LoaderService);
  private modalService = inject(NgbModal);
  private config = inject(AppConfig);

  public advisors: advisorType[] = [];
  public cardsPerRow = 4;
  public dummyCards: boolean[] = [];
  public user?: authUserType;

  ngOnInit() {
    this.user = this.auth.getUser();
    this.loaderService.display(true, 'Advisors');

    this.api.get<advisorType[]>(this.config.advisor.advisorUrl+'/'+this.auth.getCurrentReRg()!.ReRgId).subscribe(
      data => {
        this.advisors = data.sort((a, b) => {
          return a.IsPrimary > b.IsPrimary ? -1 :
                 a.IsPrimary < b.IsPrimary ? 1 :
                 a.SupportName > b.SupportName ? 1 :
                 a.SupportName < b.SupportName ? -1 :
                 0;
        });
        this.advisors.forEach(a=>{
          a.Designations = a.Designations?.replace(/®/g,'<sup>®</sup>') || '';
          a.Title = a.Title?.replace(/\|\s/g,'<br>') || '';
        });
        const dummyCount = (this.cardsPerRow - (this.advisors.length % this.cardsPerRow)) % this.cardsPerRow;
        if (dummyCount) this.dummyCards = Array(dummyCount);
        this.loaderService.display(false, 'Advisors');
      },
      () => this.loaderService.display(false, 'Advisors')
    );
  }

  loadDefaultImage(e: ErrorEvent) {
    if (e.target) {
      const img = e.target as HTMLImageElement;
      img.src ="/assets/images/teammember-placeholder.png";
    }
  }

  /**
   * it will open a modal to send message to the advisory team
   * @param content
   */
  openModalToContactAdvisoryTeam(content: TemplateRef<AdvisorContactComponent>): void {
    this.modalService.open(content, { size: 'lg' })
  }
}
